import { buildUrl } from "../util/integration";


export const reportDSANoticeAPI = (
  firstName,
  lastname,
  emailAddress,
  comment,
  type,
  id,
) => {
  return fetch(
    buildUrl("dsa"),
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        firstName,
        lastname,
        emailAddress,
        comment,
        type,
        id,
      }),
    },
  );
};